function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.39575 0.520752L0.520752 6.39575L8.85408 14.7291V80.9791H75.1041L87.6041 93.4791L93.4791 87.6041L6.39575 0.520752ZM25.5208 72.6457H17.1874V64.3124H25.5208V72.6457ZM17.1874 55.9791H25.5208V47.6457H17.1874V55.9791ZM17.1874 39.3124V30.9791H25.5208V39.3124H17.1874ZM33.8541 72.6457H42.1874V64.3124H33.8541V72.6457ZM33.8541 55.9791V47.6457H42.1874V55.9791H33.8541ZM50.5208 64.3124V72.6457H66.7708L58.4374 64.3124H50.5208ZM33.854 14.3124H42.1874V22.6457H40.3124L50.5207 32.8541V30.9791H83.854V66.1874L92.1874 74.5207V22.6457H50.5207V5.97908H23.6457L33.854 16.1874V14.3124ZM75.5208 39.3124H67.1874V47.6457H75.5208V39.3124Z",
  fill: "#EB5757"
});

var SvgClickToCallNonWorkingHours = function SvgClickToCallNonWorkingHours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "assets/click-to-call-non-working-hours.79b41c4a.svg";
export { SvgClickToCallNonWorkingHours as ReactComponent };